// MessageCategoryTabAllInOne.js
'use strict';
'use client';
import { connect } from 'react-redux';

import MessageCategoryTabAllInOne from '../component/MessageCategoryTabAllInOne.jsx';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getIsCategoryEmpty from '../selector/getIsCategoryEmpty.js';

import { CATEGORY_FEED_ALL } from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { match, categoryId: propsCategoryId }) => {
  const categoryId = propsCategoryId || match?.params?.categoryId;
  const categoryFeeds = getRemoteConfigData(
    state,
    CATEGORY_FEED_ALL,
    undefined,
    {
      CATEGORY: categoryId,
    }
  );

  return {
    categoryId,
    categoryTemplates: getRemoteConfigData(state, CATEGORY_FEED_ALL),
    categoryFeeds,
    isFetchedAndEmpty: getIsCategoryEmpty(state, categoryFeeds),
  };
};

export default connect(mapStateToProps, null)(MessageCategoryTabAllInOne);
